import React from "react";
import PropTypes from "prop-types";

import { UploadName, ErrorMessage, ErrorContainer } from "./styles";

const ErrorItem = ({ uploadName, errorMessage }) => (
    <ErrorContainer>
        <UploadName>{uploadName}</UploadName>
        <br />
        <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorContainer>
);

ErrorItem.propTypes = {
    uploadName: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired
};

export default ErrorItem;
